import { useQuery } from '@tanstack/react-query';
import { http } from '@noor/api';

interface Cuisine {
  id: string;
  name: string;
}

export function useCuisines() {
  return useQuery({
    queryKey: ['merchant-cuisines'],
    queryFn: async (): Promise<Cuisine[]> => {
      const raw = await http.get<unknown>('/merchant/cuisines');
      const body = raw as {
        data?: { cuisines?: Cuisine[] } | Cuisine[];
        cuisines?: Cuisine[];
        list?: Cuisine[];
      };
      const data = body.data;
      return Array.isArray(data)
        ? data
        : (data?.cuisines ?? body.cuisines ?? body.list ?? []);
    },
  });
}
